import { render, staticRenderFns } from "./AddSub.vue?vue&type=template&id=e9775d48&scoped=true&"
import script from "./AddSub.vue?vue&type=script&lang=ts&"
export * from "./AddSub.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9775d48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9775d48')) {
      api.createRecord('e9775d48', component.options)
    } else {
      api.reload('e9775d48', component.options)
    }
    module.hot.accept("./AddSub.vue?vue&type=template&id=e9775d48&scoped=true&", function () {
      api.rerender('e9775d48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/substitutes/AddSub.vue"
export default component.exports